import React,{useEffect} from 'react'
import { Alert } from '@chakra-ui/react'

export default function AlertMe(props) {
    
    const {showAlert,message,header,close} = props

    useEffect(() => {
        if (showAlert) {
            const timer = setTimeout(() => {
                close();
            }, 3000); // Hide after 3 seconds (3000 milliseconds)

            // Clear the timeout if the component unmounts or showAlert changes before the timer finishes
            return () => clearTimeout(timer);
        }
    }, [showAlert]);

    return <>
        {showAlert &&
            <Alert.Root {...props}>
                <Alert.Indicator />
                <Alert.Content>
                    {/* <Alert.Title>{header}</Alert.Title> */}
                    <Alert.Description>
                        {message}
                    </Alert.Description>
                </Alert.Content>
            </Alert.Root>
        }
    </>
}